import { DisconnectOutlined, MessageOutlined } from '@ant-design/icons';
import {
    mdiAccountCancelOutline,
    mdiAccountCheckOutline,
    mdiAccountClockOutline,
    mdiChairRolling,
    mdiCoffeeToGoOutline,
    mdiPhoneIncomingOutline,
    mdiPhoneLog,
    mdiPhoneOutgoingOutline
} from '@mdi/js';
import Icon from '@mdi/react';
import { agentStatusIdType } from '../../model/types';

const getAgentStatusIcon = (agentStatusId: agentStatusIdType): JSX.Element => {
    const icon: Record<agentStatusIdType, JSX.Element> = {
        1: <Icon path={mdiAccountCancelOutline} size="1.3rem" style={{ marginBottom: -3.5, marginRight: 5 }} />,
        2: <Icon path={mdiAccountCheckOutline} size="1.3rem" style={{ marginBottom: -3.5, marginRight: 5 }} />,
        3: <Icon path={mdiPhoneIncomingOutline} size="1.15rem" style={{ marginBottom: -3.5, marginRight: 7 }} />,
        4: <Icon path={mdiPhoneOutgoingOutline} size="1.15rem" style={{ marginBottom: -3.5, marginRight: 7 }} />,
        5: <Icon path={mdiPhoneLog} size="1.15rem" style={{ marginBottom: -3.5, marginRight: 8 }} />,
        6: <Icon path={mdiChairRolling} size="1.3rem" style={{ marginBottom: -3.5, marginRight: 5 }} />,
        7: <Icon path={mdiCoffeeToGoOutline} size="1.3rem" style={{ marginBottom: -5, marginRight: 6 }} />,
        8: <Icon path={mdiAccountClockOutline} size="1.3rem" style={{ marginBottom: -3.5, marginRight: 5 }} />,
        9: <MessageOutlined style={{ marginBottom: -3.5, marginLeft: 2, marginRight: 7 }} />,
        10: (
            <>
                <MessageOutlined style={{ marginBottom: -3.5, marginRight: -10, zIndex: 1 }} />
                <Icon path={mdiAccountCheckOutline} size="1rem" style={{ marginBottom: -8, marginRight: -2 }} />
            </>
        ),
        11: (
            <>
                <MessageOutlined style={{ marginBottom: -3.5, marginRight: -8, zIndex: 1 }} />
                <Icon path={mdiPhoneIncomingOutline} size="1rem" style={{ marginBottom: -8, marginRight: -5 }} />
            </>
        ),
        12: (
            <>
                <MessageOutlined style={{ marginBottom: -3.5, marginRight: -8, zIndex: 1 }} />
                <Icon path={mdiPhoneOutgoingOutline} size="1rem" style={{ marginBottom: -8, marginRight: -5 }} />
            </>
        ),
        13: (
            <>
                <MessageOutlined style={{ marginBottom: -3.5, marginRight: -8, zIndex: 1 }} />
                <Icon path={mdiPhoneLog} size="1rem" style={{ marginBottom: -8, marginRight: -5 }} />
            </>
        )
    };
    return icon?.[agentStatusId] ?? <DisconnectOutlined />;
};

export default getAgentStatusIcon;
